<template>
  <div class="unknown">
        <el-form ref="form" label-width="96px" :model="form">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="分公司" prop="branchCompanyId">
                        <el-select v-model="form.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
                            <el-option
                                v-for="item in listBranch"
                                :key="item.id"
                                :label="item.companyFullName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>    
                </el-col>
                <el-col :span="6">
                <el-form-item label="子公司" prop="companyId">
                    <el-select v-model="form.companyId" filterable placeholder="请选择">
                        <el-option
                            v-for="item in listSon"
                            :key="item.id"
                            :label="item.companyFullName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        @change="startTime"
                        v-model="form.startTimeString"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        @change="endTime"
                        v-model="form.endTimeString"
                        align="right"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex">
            <el-col :span="6">
            <el-form-item label="处理状态" prop="resultStatus">
                <el-select v-model="form.resultStatus" placeholder="请选择">
                <el-option
                    v-for="item in listExamine2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
                </el-select>
            </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="报未知角色" prop="roleId">
                    <el-select v-model="roleId" filterable placeholder="请选择">
                        <el-option
                            v-for="item in roleList"
                            :key="item.roleId"
                            :label="item.roleName+'-'+item.userName"
                            :value="item.roleId"
                         ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="时间类型筛选" prop="orderType">
                    <el-radio-group v-model="form.orderType">
                        <el-radio :label="0">全部</el-radio>
                        <el-radio :label="1">处理时间</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :span="6">
            <el-form-item prop="searchInput" style="flex: 1;">
                <el-input
                    v-model.trim="form.searchString"
                    placeholder="国内单号、未知编号"
                    style="width: 50%;"
                ></el-input>
                <el-button type="primary" @click="searchForm" style="margin-left:10px;">搜索</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
            </el-col>
            </el-row>
            </el-form>
            <el-row>
                <el-button type="primary" @click="Create">创建</el-button>
                <el-button type="primary" @click="unkonwnClick">未知记录</el-button>
            </el-row>

              <el-table :data="tableData" border style="width: 100%;margin-top:20px;" v-loading="loadingTable" :header-cell-style="{ textAlign: 'center' }">
                  <el-table-column prop="unknownNumber" label="未知编号" align="center"></el-table-column>
                  <el-table-column prop="" label="异常信息" align="left" width="300px">
                    <template slot-scope="scope">
                      <el-row type="flex">
                        <el-popover trigger="hover" placement="right">
                          <img :src="scope.row.unknownImages[0]" alt  style="width:500px;height:500px;"/>
                          <div class="scope_img" slot="reference">
                            <img :src="scope.row.unknownImages[0]" alt style="width:50px;height:50px;margin-left:10px;"/>
                          </div>
                        </el-popover>
                        <div style="margin-left:10px;">
                          <p>{{ scope.row.unknownDescription }}</p>
                        </div>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column prop="internalConveyNumber" label="国内单号" align="center"></el-table-column>
                  <el-table-column label="结果" align="center">
                      <template slot-scope="scope">
                          <span style="color: red;" v-if="scope.row.resultStatus === 0">未处理</span>
                          <span style="color: blue;" v-else-if="scope.row.resultStatus === 1">申请转库存</span>
                          <span style="color: blue;" v-else-if="scope.row.resultStatus === 3">申请退件</span>
                          <span style="color: blue;" v-else-if="scope.row.resultStatus === 5">申请关联采购需求</span>
                          <span style="color: blue;" v-else-if="scope.row.resultStatus === 7">重新入库</span>
                      </template>
                  </el-table-column>
                <el-table-column prop="handleDescription" label="处理方案" align="center"></el-table-column>
                <el-table-column label="知会方" align="center">
                    <template slot-scope="scope">
                        {{scope.row.branchCompanyName}}-{{scope.row.subCompanyName}}
                    </template>
                </el-table-column>
                <el-table-column prop="handleTime" label="采购处理时间" sortable align="center"></el-table-column>
                <el-table-column width="200" prop="errorRoleId" label="报未知角色" align="center">
                        <template slot-scope="scope">
                            <div>
                                <span>{{ scope.row.roleName }}</span>
                                <span v-if="scope.row.roleName && scope.row.userName">&nbsp;-&nbsp;</span>
                                <span>{{ scope.row.userName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                <el-table-column prop="createTime" label="报未知时间" sortable align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="150">
                      <template slot-scope="scope">
                          <div>
                            <el-button type="primary" @click="operation(scope.row)">未知件详情</el-button>
                          </div>
                          <div style="margin-top:5px;">
                            <el-button style="margin-left:0px;" @click="print(scope.row)">打印未知单</el-button>
                          </div>
                      </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>

            <el-dialog title="未知提交" :visible.sync="dialogVisible" width="27%">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="知会方：" prop="Notify">
                            <el-select v-model="ruleForm.Notify" filterable placeholder="选择知会方" style="width:100%;">
                                <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.companyFullName"
                                :value="item.id">
                                </el-option>
                            </el-select>
                    </el-form-item>
                    <el-form-item label="国内运单：" prop="DomesticWaybill">
                            <el-input type="text" v-model="ruleForm.DomesticWaybill" placeholder="填写国内运单"></el-input>
                            <!-- <el-select v-model="ruleForm.DomesticWaybill" filterable allow-create default-first-option placeholder="填写国内运单" style="width:100%;">
                                <el-option
                                v-for="item in UnknownList"
                                :key="item.id"
                                :label="item.internalConveyNumber"
                                :value="item.internalConveyNumber">
                                </el-option>
                            </el-select> -->
                    </el-form-item>
                    <el-form-item label="未知说明：" prop="textarea">
                            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="ruleForm.textarea"></el-input>
                    </el-form-item>
                  <el-form-item>
                    <el-select :value="abnormalContent" @change="setExceptionRemark" style="width: 100%;" filterable>
                      <el-option v-for="item in listAbnormalWords" :key="item.id" :label="item.typeName"
                                 :value="item.content"></el-option>
                    </el-select>
                  </el-form-item>

                </el-form>
                <div>
                        <el-upload
                            ref="upload"
                            :action="action"
                            list-type="picture-card"
                            :on-success="handleAvatarSuccess"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            :headers="customHeaders"
                        >
                        <i class="el-icon-plus" style="color: #0724ef;"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible1" append-to-body>
                            <img width="100%" :src="dialogImageUrl1" alt />
                        </el-dialog>
                    </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="resetForm('ruleForm')">取 消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </span>
            </el-dialog>

            <el-dialog title="未知记录" :visible.sync="dialogTableVisible" width="40%">
                <el-table :data="listUnknown" border>
                    <el-table-column property="internalConveyNumber" label="未知国内单号" align="center"></el-table-column>
                    <el-table-column property="putStorageTime" label="入库时间" align="center"></el-table-column>
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button type="danger" @click="delUnknown(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="warning" @click="clearUnknown">清 空</el-button>
                    <el-button type="primary" @click="dialogTableVisible = false">完 成</el-button>
                </span>
            </el-dialog>

            <el-dialog title="未知件详情" :visible.sync="details" width="26%" class="details">
                <el-form>
                    <el-form-item label="未知件编号：">
                        <span>{{detailsList.unknownNumber}}</span>
                    </el-form-item>
                    <el-form-item label="国内运单号：">
                        <span>{{detailsList.internalConveyNumber}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-row class="box">
                        <div v-for="item in this.imageList">
                            <div class="demo-image__preview">
                                <el-image 
                                    style="width:100px;height:100px;margin-left:10px;"
                                    :src="item" 
                                    :preview-src-list="[item]">
                                </el-image>
                            </div>
                        </div>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="未知说明：">
                        <span style="color: red;">{{detailsList.unknownDescription}}</span>
                    </el-form-item>
                    <el-row type="flex" align="middle" style="margin: 10px 0;">
                      <div>处理方案：</div>
                      <div>{{ detailsList.handleDescription }}</div>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="deleteProduct">删除</el-button>
                    <el-button type="primary" v-if="detailsList.resultStatus == 7" @click="againPutWarehouse">重新入库</el-button>
                    <el-button type="primary" v-if="detailsList.resultStatus == 5" @click="associated">关联采购需求</el-button>
                    <el-button type="primary" v-if="detailsList.resultStatus == 1" @click="inventory">转库存</el-button>
                    <el-button type="primary" v-if="detailsList.resultStatus == 3" @click="TheProduct">退件</el-button>
                </span>
            </el-dialog>

  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    data() {
      return {
        str:"",
        form:{
            startTimeString:"",
            endTimeString:"",
            branchCompanyId:"",
            companyId:"",
            searchString:"",
            resultStatus: '',
            orderType:0
        },
        ruleForm:{
            Notify:"",
            DomesticWaybill:"",
            textarea:"",
        },
        options:[],
        tableData:[],
        listUnknown:[],
        UnknownList:[],
        dialogTableVisible: false,
        dialogVisible:false,
        details:false,
        detailsList:"",

        dialogVisible1: false,
        dialogImageUrl1: "",
        action: Baseurl + "imageController/uploadImage",
        customHeaders: { token: localStorage.getItem("token") },
        imageData: [],
        arrimage:[],
        imageList:[], 

        currentPage: 1,
        pagesize: 50,
        size: 50,
        total: 0,

        rules: {
          Notify: [
            { required: true, message: '请选择知会方', trigger: 'blur' },
          ],
          DomesticWaybill: [
            { required: true, message: '请填写国内运单', trigger: 'blur' },
          ],
          textarea: [
            { required: true, message: '请填写未知说明', trigger: 'blur' },
          ],
        },
        listExamine2: [
          { value: 0, label: '未处理' },
          { value: 1, label: '申请转库存' },
        //   { value: 2, label: '确认转库存' },
          { value: 3, label: '申请退件' },
        //   { value: 4, label: '确认退件' },
          { value: 5, label: '申请关联采购需求' },
        //   { value: 6, label: '确认关联采购需求' }
          { value: 7, label: '重新入库' },
        ],
        loadingTable: false,
        listAbnormalWords: [],
        abnormalContent: '',
        listBranch:[],
        listSon:[],
        roleList:[],
        roleId:""

      }
    },
    created(){
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search()
        this.getBranchCompanyList()
        this.getUnknownRoleNameList()
    },
    methods: {
        search(){
            var obj = {
                companyId:this.str.company_id,
                startTimeString: this.form.startTimeString,
                endTimeString: this.form.endTimeString,
                searchString: this.form.searchString,
                resultStatus: this.form.resultStatus,
                branchCompanyId:this.form.branchCompanyId,
                subCompanyId:this.form.companyId,
                orderType:this.form.orderType,
                page:this.currentPage,
                size:this.size,
                type:2,
                roleId:this.roleId
            };
            this.loadingTable = true
            ajaxPost(Baseurl + "unknownManageController/selectUnknownManageList", obj).then(res => {
                this.loadingTable = false
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listBranch = data;
                }
            });
        },
        getUnknownRoleNameList() {
            ajaxPost(Baseurl + "unknownManageController/getUnknownRoleNameList").then(res => {
                const { code, data } = res.data;
                if(code == 200){
                    this.roleList = data
                }
            });
        },
        selectChange(val){
            var obj = {
                id:val
            }
            ajaxPost(Baseurl + "logisticsController/getAllSubCompanyById", obj).then(res => {
                this.listSon = res.data.data
                this.form.companyId = ""
            });
        },
        Create(){
            this.dialogVisible = true
            this.unkonwnList()
            this.getAbnormalList()
            this.selectList()
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    for (var i = 0; i < this.imageData.length; i++) {
                        this.arrimage.push(this.imageData[i].data);
                    }
                    if(this.arrimage.length == 0){
                        this.$message.error('请上传未知库存的运单截图');
                    }else{
                    //    replace(/(^\s*)|(\s*$)/g, ""); 前后空格
                        // replace(/\s+/g,"") 所有空格
                        // console.log(this.ruleForm.DomesticWaybill);
                        // console.log(this.ruleForm.DomesticWaybill.replace(/\s+/g,""));
                        // console.log(this.ruleForm.DomesticWaybill.replace(/(^\s*)|(\s*$)/g, ""));
                        let internalConveyNumber = this.ruleForm.DomesticWaybill.replace(/\s+/g,"");
                        // return;
                        var obj = {
                            roleId:this.str.rid,
                            companyId:this.ruleForm.Notify,
                            internalConveyNumber,
                            unknownDescription:this.ruleForm.textarea,
                            unknownImages:this.arrimage
                        }
                        ajaxPost(Baseurl + "unknownManageController/insertUnknownManage", obj).then(res => {
                            if(res.data.code == 200){
                                this.$message({
                                    message: '创建未知提交成功',
                                    type: 'success'
                                });
                                this.search()
                            }else{
                                this.$message.error(res.data.data);
                            }
                            this.$refs.upload.clearFiles();
                            this.imageData = []
                            this.arrimage = []
                            this.$refs[formName].resetFields();
                            this.dialogVisible = false
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.dialogVisible = false
            this.imageData = []
            this.$refs.upload.clearFiles();
            this.$refs[formName].resetFields();
        },
        selectList(){
            ajaxPost(Baseurl + "unknownManageController/selectAllSubCompany").then(res => {
                this.options = res.data.data;
                // console.log(res.data)
            });
        },
        searchForm() {
          this.currentPage = 1
          this.search()
        },
        reset(){
            this.form.branchCompanyId = ""
            this.form.companyId = ""
            this.form.startTimeString = ""
            this.form.endTimeString = ""
            this.form.searchString = ""
            this.form.resultStatus = ""
            this.form.orderType = 0
            this.listSon = []
            this.currentPage = 1
            this.roleId = ""
            this.search()
        },
        operation(val){
            this.details = true
            this.detailsList = val
            this.imageList = val.unknownImages
        },
        handleAvatarSuccess(file, fileList) {
            this.imageData.push(file);
        },
        handleRemove(file, fileList) {
            this.imageData = [];
            for (var i = 0; i < fileList.length; i++) {
                this.imageData.push(fileList[i].response);
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl1 = file.url;
            this.dialogVisible1 = true;
        },
        //关联采购需求
        associated(){
            var obj = {
                id:this.detailsList.id,
                resultStatus:6,
                roleId: this.str.rid
            };
            ajaxPost(Baseurl + "unknownManageController/updateUnknownManage", obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: '确认关联采购需求',
                        type: 'success'
                    });
                    this.search()
                    this.details = false
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        //转库存
        inventory(){
            var obj = {
                id:this.detailsList.id,
                resultStatus:2,
                roleId: this.str.rid
            };
            ajaxPost(Baseurl + "unknownManageController/updateUnknownManage", obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: '确认转库存',
                        type: 'success'
                    });
                    this.search()
                    this.details = false
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        //退件
        TheProduct(){
            var obj = {
                id:this.detailsList.id,
                resultStatus:4,
                roleId: this.str.rid
            };
            ajaxPost(Baseurl + "unknownManageController/updateUnknownManage", obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: '确认退件',
                        type: 'success'
                    });
                    this.search()
                    this.details = false
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        startTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00";
            this.form.startTimeString = datetime;
            // console.log(this.ruleForm.startTimeString);
        },
        endTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";
            this.form.endTimeString = datetime;
            // console.log(this.ruleForm.endTimeString);
        },
        unkonwnClick() {
            const API = Baseurl + "logisticsController/getUnknownPurchaseList";

            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listUnknown = data;
                    this.dialogTableVisible = true;
                }
            });
        },
        unkonwnList(){
            const API = Baseurl + "logisticsController/getUnknownPurchaseList";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.UnknownList = data;
                }
            });
        },
        getAbnormalList() {
          const API = Baseurl + 'abnormalCommonWordController/selectAbnormalCommonWordList'
          ajaxPost(API).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.listAbnormalWords = data
            }
          })
        },
        setExceptionRemark(e) {
          this.ruleForm.textarea = e
          this.abnormalContent = ''
        },
        delUnknown(val){
            const API = Baseurl + "logisticsController/deleteUnknownPurchase";
            const paramsData = {
                id: val.id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.$message.success("删除成功！");
                    this.unkonwnClick();
                } else {
                    this.$message.error("删除失败！");
                }
            });
        },
        clearUnknown() {
            const API = Baseurl + "logisticsController/emptyUnknownPurchase";
            const paramsData = {
                unknownPurchases: this.listUnknown.map(item => ({
                    id: item.id,
                })),
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.$message.success("操作成功！");
                    this.unkonwnClick();
                } else {
                    this.$message.error("操作错误！");
                }
            });
        },
        handleSizeChange(val){
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search()
        },
        deleteProduct() {
          this.$confirm('确定要删除吗？', '提示').then(() => {
            const API = Baseurl + 'unknownManageController/updateDeleteStatus'
            const paramsData = { id: this.detailsList.id }
            ajaxPost(API, paramsData).then(res => {
              const { code } = res.data
              if (code === 200) {
                this.$message.success('操作成功！')
                this.details = false
                this.search()
              }
            })
          })
        },
      againPutWarehouse() {
        const API = Baseurl + 'unknownManageController/updateUnknownManage'
        const paramsData = {
          id: this.detailsList.id,
          resultStatus: 8,
          roleId: this.str.rid
        }
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            this.$message.success('操作成功')
            this.search()
            this.details = false
          } else {
            this.$message.error(data || '操作失败')
          }
        })
      },
      print(val){
          const API = Baseurl + 'unKnownPdfPrintController/pdfUnKnownPrint'
            const paramsData = {
                id: val.id
            }
            ajaxPost(API, paramsData).then(res => {
                if (res.data.code === 200) {
                window.open(res.data.data, '_blank');
                } else {
                this.$message.error(res.data.data)
                }
            })
      }
    }
}
</script>

<style lang="scss" scoped>

.unknown{
    margin-top: 30px;
    margin-bottom:50px;
}
.box{
    display: flex;
    justify-content: left;
}
.page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
</style>
<style lang="scss" scoped>
/deep/{
    .details .el-form-item{
        margin-bottom: 0px!important;
    }
}
</style>